// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home[data-v-fae5bece] {\n  height: calc(100% - 20px);\n  margin: 8px;\n}\n.home-mobile[data-v-fae5bece] {\n  height: 100%;\n  margin: 0px;\n}\n.float-container-bottom-center[data-v-fae5bece] {\n  position: absolute;\n  margin-bottom: 30px;\n  margin-right: 55px;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  padding: 8px 8px;\n}", ""]);
// Exports
module.exports = exports;
